import PropertyDetail from "../../commonComponents/productDetail/PropertyDetail";

const PropertyImageSliderContainer = () => {
  return <PropertyDetail type="image-slider" />;
};

export default PropertyImageSliderContainer;
